import { Cubit } from "blac-next";

interface AppDebugState {
  extra: Record<string, unknown>;
  show: boolean;
}

export default class AppDebugCubit extends Cubit<AppDebugState> {
  private isOpenSessStorageKey = "debug-bloc-is-open";
  isMinifiedSessStorageKey = "debug-bloc-is-minified";

  private triggerWord = "debug9am";
  private lastKeys = "";
  private countMovePastMiddle = 0;
  private middle = window.innerWidth / 2;
  private aboveMiddle = false;

  constructor() {
    super({ extra: {}, show: false });
  }

  init = () => {
    const isOpen = sessionStorage.getItem(this.isOpenSessStorageKey);
    if (isOpen === "true") {
      this.setShow(true);
    }
  };

  private typeListener = (e: KeyboardEvent) => {
    this.lastKeys = this.lastKeys + e.key;
    this.lastKeys = this.lastKeys.slice(-this.triggerWord.length);
    if (this.lastKeys === this.triggerWord) {
      this.toggleOrReset();
    }
  };

  private touchListener = (e: TouchEvent) => {
    if (e.touches.length > 1) {
      return;
    }
    const [touch] = e.touches;
    if (touch.clientX > this.middle) {
      if (!this.aboveMiddle) {
        this.countMovePastMiddle++;
        if (this.countMovePastMiddle > 5) {
          this.setShow(true);
        }
      }
      this.aboveMiddle = true;
    } else {
      this.aboveMiddle = false;
    }
  };

  private touchEndListener = () => {
    this.countMovePastMiddle = 0;
  };

  setShow = (show: boolean): void => {
    this.emit({ ...this.state, show });
    sessionStorage.setItem(this.isOpenSessStorageKey, String(show));
  };

  toggleOrReset = (): void => {
    if (this.state.show) {
      this.setShow(false);
      setTimeout(() => this.setShow(true), 50);
    } else {
      this.setShow(true);
    }
  };

  addCustomListeners = () => {
    document.addEventListener("keydown", this.typeListener, { passive: true });
    window.addEventListener("touchmove", this.touchListener, { passive: true });
    window.addEventListener("touchend", this.touchEndListener, {
      passive: true
    });
  };

  removeCustomListeners = () => {
    document.removeEventListener("keydown", this.typeListener);
    window.removeEventListener("touchmove", this.touchListener);
    window.removeEventListener("touchend", this.touchEndListener);
  };

  setExtra = (extra: Record<string, unknown>): void => {
    this.emit({ ...this.state, extra });
  };
}
